// oxlint-disable-next-line import/named
import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

if (window.location.hash.startsWith('#/')) {
  history.replace(window.location.hash.slice(1));
}

export default history;
